import {ITEM_TYPE} from './canvas_timeline_util';

class Item {
	constructor(itemType, data) {
		this.itemType = itemType;
		if (data) {
			this.updateWithData(data);
		}
	}

	updateWithData(data) {
		this.height = this.getItemHeightFromItemType(this.itemType, data);
		this.groupId = data.groupId;
		this.startDate = data.startDate;
		this.endDate = data.endDate;
		this.visible = data.visible === null || data.visible === undefined ? true : data.visible;
		this.onClick = data.onClick;
		this.draggableType = data.draggableType;
		this.draggableArea = data.draggableArea;
		this.data = data;
		this.onMoveAttempt = data.onMoveAttempt;
		this.onMouseEnter = data.onMouseEnter;
		this.onMouseLeave = data.onMouseLeave;
		this.onMoveStart = data.onMoveStart;
		this.onMoving = data.onMoving;
		this.onMoveEnd = data.onMoveEnd;
		this.onMoveAnimationEnd = data.onMoveAnimationEnd;
		this.onDraw = data.onDraw;
		this.allowDependencyCreation = data.allowDependencyCreation;
		this.horizontalExtension = data.horizontalExtension || (data.allowDependencyCreation ? 26 : 0);
		this.updateFreeDragData = data.updateFreeDragData;
	}

	getItemHeightFromItemType(itemType, data) {
		switch (itemType) {
			case ITEM_TYPE.PROJECT_SCHEDULING_PROJECT:
				return 37;
			case ITEM_TYPE.PROJECT_SCHEDULING_PHASE:
				return 33;
			case ITEM_TYPE.PROJECT_SCHEDULING_TASK:
				return 27;
			case ITEM_TYPE.PEOPLE_SCHEDULING_HEATMAP:
				return 47;
			case ITEM_TYPE.PEOPLE_SCHEDULING_PROJECT_ALLOCATION:
				return 35;
			case ITEM_TYPE.PROJECT_SCHEDULING_PROJECT_ALLOCATION:
				return 35;
			case ITEM_TYPE.PROJECT_SCHEDULING_TEAM_ITEM:
				return 18;
			case ITEM_TYPE.PEOPLE_SCHEDULING_TASK:
				return 35;
			case ITEM_TYPE.PEOPLE_SCHEDULING_TIME_REGISTRATION:
				return 47;
			case ITEM_TYPE.PEOPLE_SCHEDULING_TASK_ALLOCATION:
				return 35;
			case ITEM_TYPE.PEOPLE_SCHEDULING_UNASSIGNED_TASK:
				return 47;
			case ITEM_TYPE.PEOPLE_SCHEDULING_UNASSIGNED_HEATMAP:
				return 47;
			case ITEM_TYPE.PROJECT_SCHEDULING_TASK_ALLOCATION:
				return 35;
			case ITEM_TYPE.PEOPLE_SCHEDULING_COMPANY_UTILIZATION:
				return 47;
			case ITEM_TYPE.DATE_RANGE:
				return 0;
			default:
				// eslint-disable-next-line no-console
				console.warn('Unrecognized itemType type. Using default height of 40px. Check getItemHeightFromItemType function in canvas_timeline_item.');
				return 40;
		}
	}

	hide() {
		this.visible = false;
	}

	show() {
		this.visible = true;
	}

	resetItemRow() {
		this.itemRow = undefined;
		this.groupedItemRow = undefined;
	}

	shift(dayDifference, startDifference, endDifference) {
		//Need to make sure difference is an integer
		const parsedDayDifference = parseInt(dayDifference, 10);
		const parsedStartDayDifference = startDifference ? parseInt(startDifference, 10) : null;
		const parsedEndDayDifference = endDifference ? parseInt(endDifference, 10) : null;
		if (!parsedDayDifference) return;
		this.startDate += parsedStartDayDifference || parsedDayDifference;
		this.endDate += parsedEndDayDifference || parsedDayDifference;
	}
}

export default Item;
